import { createContext } from 'react';
import { GetAuthedUserPermissionsResponse } from '../api/dtos';

const AuthenticationContext = createContext<GetAuthedUserPermissionsResponse | null>(null);

export default AuthenticationContext;